import React from "react";
import styles from "./Button.module.scss";
import "./Button.scss";

/**
 * Customizable button component.
 *
 * @param {{
 *  text: string,
 *  icon?: import("react").ReactNode,
 *  prefixIcon?:import("react").ReactNode,
 *  type?: "button" | "submit" | "reset",
 *  onClick?: React.MouseEventHandler<HTMLButtonElement>,
 *  disabled?: boolean,
 *  outlined?: boolean,
 *  inverted?: boolean,
 *  className?: string
 * }} props - Props for the Button.
 * @returns {JSX.Element} The rendered button.
 */
function Button({
  text,
  icon,
  prefixIcon,
  type = "button",
  onClick = undefined,
  disabled = false,
  outlined = false,
  inverted = false,
  className,
}) {
  const cls =
    styles[`btn${inverted ? "Invert" : "Primary"}${outlined ? "Outlined" : "Filled"}${disabled ? "Disabled" : ""}`];

  return (
    <button type={type} className={`btn ${cls} ${className}`} onClick={onClick} disabled={disabled}>
      {icon && icon}
      <span>{text}</span>
      {prefixIcon && prefixIcon}
    </button>
  );
}

export default Button;
